import { ThemeUIStyleObject } from 'theme-ui';

import { GridChildProps } from './GridChild';

const getColSpanStyle = (columnSpan: GridChildProps['columnSpan']): ThemeUIStyleObject => {
  return typeof columnSpan === 'object' && columnSpan !== null
    ? {
        gridColumnStart: columnSpan.start || 'auto',
        gridColumnEnd: columnSpan.columns
          ? Array.isArray(columnSpan.columns)
            ? columnSpan.columns.map((column) => (column ? `span ${column}` : null))
            : `span ${columnSpan.columns}`
          : '-1'
      }
    : { gridColumn: columnSpan ? `auto / span ${columnSpan}` : '1 / -1' };
};

export const stylePropsGridChild = ({
  align,
  alignSelf,
  padding,
  rowStart,
  rowSpan,
  columnSpan
}: Partial<GridChildProps>): ThemeUIStyleObject => ({
  justifySelf: align,
  alignSelf: alignSelf,
  p: padding,
  gridRowStart: rowStart,
  gridRowEnd: rowSpan ? `span ${rowSpan}` : undefined,
  ...getColSpanStyle(columnSpan)
});
